module.exports = __webpack_public_path__ + "img/335.84282a05.svg";